import styled from 'vue-styled-components'

const componentProps = {
  size: {
    type: String,
    default: 'auto'
  },
  width: String,
  height: String
}

const StyledSvgCustom = styled('span', componentProps)`
  &.ico {
    width: ${(props) => (props.width ? props.width : props.size)} !important;
    height: ${(props) => (props.height ? props.height : props.size)} !important;

    svg {
      fill: #fff;
    }
  }
`

export default StyledSvgCustom
